"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clone_1 = __importDefault(require("lodash/clone"));
/**
 * This Class is a Static Singleton that allows the logging of
 * activity via the frontend Application.
 */
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.logCache = [];
        this.dataProviders = [];
        this.enabled = false;
        this.registerDebounce();
    }
    /**
     * Enable the analytics class.
     * @param enabled {boolean}
     */
    Analytics.prototype.enableAnalytics = function (enabled) {
        this.enabled = enabled;
    };
    /**
     * Enable the analytics class.
     * @param url { string }
     */
    Analytics.prototype.setUrl = function (url) {
        this.url = url;
    };
    /**
     * Register a new debounce timeout.
     * @private
     */
    Analytics.prototype.registerDebounce = function () {
        var _this = this;
        setTimeout(function () {
            _this.debounce();
        }, 7000);
    };
    /**
     * Process a debounce request.
     * @private
     */
    Analytics.prototype.debounce = function () {
        this.purgeQueue();
        this.registerDebounce();
    };
    /**
     * Send the current log queue.
     */
    Analytics.prototype.purgeQueue = function () {
        var cache = clone_1.default(this.logCache);
        this.logCache = [];
        if (cache.length > 0) {
            this.sendData(cache);
        }
    };
    /**
     * Log an analytics request
     * @param type {string} the key for the analytics event
     * @param data {Object}  Data associated with the event
     */
    Analytics.prototype.log = function (type, data) {
        var payload = {
            type: type,
            data: data,
            time: new Date().toISOString()
        };
        /*
         * Run any data providers over the payload and allow them to mutate it.
         */
        for (var i in this.dataProviders) {
            if (typeof this.dataProviders[i] === "function") {
                this.dataProviders[i](payload);
            }
        }
        this.logCache.push(payload);
    };
    /**
     * Add an additional data provider that can mutate the payload request.
     * @param callback
     */
    Analytics.prototype.registerDataProvider = function (callback) {
        this.dataProviders.push(callback);
    };
    /**
     * Send the log payload to a server if we aren't in development mode.
     * @param payload
     * @private
     */
    Analytics.prototype.sendData = function (payload) {
        if (this.enabled) {
            navigator.sendBeacon(this.url, JSON.stringify(payload));
        }
    };
    return Analytics;
}());
exports.Analytics = Analytics;
// Export a new static instance of the Analytics Class.
exports.AnalyticsSingleton = new Analytics();
//# sourceMappingURL=data:application/json;base64,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